import React, { useId } from 'react';

// Fixed gradient magnifying-glass icon used across search inputs.
// Self-contained: size and left margin are baked in so it drops in
// as a search-field adornment without extra styling.
// useId gives each instance unique gradient ids (avoids duplicate-id
// collisions when several search icons share a page).
const SearchGradientIcon = ({ style = {}}) => {
  const id = useId();
  const ringId = `search_ring_${id}`;
  const handleId = `search_handle_${id}`;

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: '1rem', ...style }}
    >
      <circle
        cx="6.5"
        cy="6.5"
        r="5.7"
        stroke={`url(#${ringId})`}
        strokeWidth="1.6"
      />
      <path
        d="M10 10L14 14"
        stroke={`url(#${handleId})`}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id={ringId}
          x1="-3.25"
          y1="3.25"
          x2="9.75"
          y2="16.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient
          id={handleId}
          x1="9"
          y1="11"
          x2="13"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SearchGradientIcon;
